<template>
  <div>
    <div id="chattool" class="text-xs-center">
      <v-tabs v-model="chattooltype" color="grey lighten-3" :slider-color="$vuetify.theme.primary">
        <v-tab :key="'customer'" ripple :href="'#customer'">{{ $t('Info') }}</v-tab>
        <v-tab :key="'ticket'" ripple :href="'#ticket'">{{ $t('Ticket') }} </v-tab>
      </v-tabs>
    </div>

    <div
      id
      v-resize="onResizeToolList"
      style="overflow-y: auto"
      :style="{ height: toolListHeight + 'px' }"
    >
      <div v-if="chattooltype == 'ticket'">
        <ticket-list
          :key="`ticket_list_${selectedUser.id}`"
          v-model="selectedUser.id"
          :pageid="pageid"
        ></ticket-list>
      </div>
      <div v-if="chattooltype == 'customer'">
        <template v-if="user">
          <customer-detail
            v-model="selectedUser"
            :pageid="pageid"
            :getuseronly="true"
            :loaduser="false"
          >
            <div slot="header">&nbsp;</div>
          </customer-detail>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import CustomerDetail from '@/components/view/dashboard/customer/CustomerDetail.vue'
import TicketList from '@/components/view/livechat/TicketList'

export default {
  components: {
    CustomerDetail,
    TicketList
  },
  props: ['value', 'pageid'],
  data() {
    return {
      loading: true,
      user: undefined,
      chatboxHeight: 0,
      session: '',
      assignadminname: '',
      chattooltype: 'customer',
      toolListHeight: 0,
      allrentcustomer: [],
      allrentsupplier: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedUser() {
      return this.user
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      var vm = this

      if (newVal == null) {
        vm.user = undefined
      } else if (newVal !== null && newVal.userid != oldVal.userid) {
        vm.loading = true

        vm.getUser(newVal.userid).then(
          function (user) {
            if (user) {
              vm.user = user
            }
            vm.loading = false
          },
          function (error) {
            vm.loading = false
          }
        )
      }
    }
  },
  mounted() {
    var vm = this
    vm.loading = true
    if (vm.value) {
      vm.getUser(vm.value.userid).then(
        function (user) {
          if (user) {
            vm.user = user
            vm.session = user.session ? user.session : ''
            vm.assignadminname = user.adminname
          }
          vm.loading = false
        },
        function (error) {
          vm.loading = false
        }
      )
    }
  },
  methods: {
    changeAsssign(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          adminname: value
        }
      }
      api.saveuseradminname(data, (error, response) => {
        if (error) {
          // reject(error)
        }
      })
    },
    changeSession(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          session: value
        }
      }
      api.saveusersession(data, (error, response) => {
        if (error) {
          // reject(error)
        }
      })
    },
    onResizeChatbox: function () {
      var vm = this
      setTimeout(() => {
        vm.chatboxHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
      }, 500)
    },
    getUser: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.pageid
        }
        api.getUserOnly(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
    onResizeToolList: function () {
      var vm = this
      vm.$nextTick(function () {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentTool.vue